import Payment from "./Payment.js";
import Spinner from 'spin';
import Config from 'config';
import Card from 'card';
import moment from 'moment';
import PaymentValid from 'payment';
import AuthDataStorage from "./AuthDataStorage";

export default class AddonsPayment extends Payment {
    constructor() {
        super();
        let queryStrings = window.location.search.substr(1).split("&");

        this.addonsIds = [];
        this.groupLicenceId = null;
        this.groupLicence = null;
        this.suspended = false;
        this.licenses = [];
        this.rewrite = false;

        queryStrings.forEach((queryString) => {
            if (queryString.indexOf("id=") === 0) {
                let idsStr = queryString.substr(3);
                this.addonsIds = idsStr.split(',').map(function (item) {
                    return parseInt(item);
                })
            }
            if (queryString.indexOf("groupLicence=") === 0) {
                let id = queryString.substr(13);
                if (id.indexOf(',') === -1)
                    this.groupLicenceId = parseInt(queryString.substr(13));
                else {
                    this.groupLicenceId = id.split(',').map(function (item) {
                        return parseInt(item);
                    })
                }
            }
            if (queryString.indexOf("suspended=") === 0) {
                this.suspended = queryString.substr(10) == "true";
            }
            if (queryString.indexOf("rewrite=") === 0) {
                this.rewrite = queryString.substr(8) == "true";
            }
        });
        if (!this.groupLicenceId)
            this.getLicenceInfo();
        else {
            this.getGroupLicence(function () {
                this.getLicenceInfo();
            }.bind(this));
        }
    }

    getGroupLicence(callback) {
        var request = new XMLHttpRequest();

        request.onreadystatechange = function() {
            if (request.readyState == 4) {
                if (request.status != 200) {
                    return this.paymentError('Their was an error dealing with your request please try again.');
                }

                var response = JSON.parse(request.responseText);
                this.groupLicence = response;
                if (typeof callback == "function") {
                    callback.call(this);
                }

            }
        }.bind(this);

        let userData = JSON.parse(this.authDataStorage.getUserData());
        let data = {
            id: this.groupLicenceId
        };
        request.open("POST", Config.BACKEND_URL + '/getGroupAddonLicense');
        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        request.setRequestHeader("auth-token", userData.token);
        request.send(JSON.stringify(data));
    }

    setupPaymentForm() {
        this.paymentTypesElement = document.getElementsByClassName('payment-types')[0];
        this.paymentInfoElement = document.getElementsByClassName('payment-info')[0];
        this.licenceInfoElement = document.getElementsByClassName('licence-info')[0];
    }

    setupPaymentInfo() {
        if (!this.groupLicence) {
            let amount = 0;
            for (let licenseId in this.licenses) {
                if (this.licenses.hasOwnProperty(licenseId)) {
                    amount += this.licenses[licenseId].monthAmount;
                }
            }
            this.paymentInfoElement.getElementsByClassName('date')[0].innerHTML = "today";
            this.paymentInfoElement.getElementsByClassName('amount')[0].innerHTML = amount;
        } else {
            if (this.groupLicence.list === undefined) {
                let dynamic = JSON.parse(this.groupLicence.GroupLicenceDynamic);
                this.paymentInfoElement.getElementsByClassName('amount')[0].innerHTML = dynamic.monthAmount;
                this.paymentInfoElement.getElementsByClassName('date')[0].innerHTML = moment(this.groupLicence.GroupLicenceNextRenewal).format("MMMM Do YYYY");
            } else {
                let amount = 0;
                for (let i = 0; i < this.groupLicence.list.length; i++) {
                    let dynamic = JSON.parse(this.groupLicence.list[i].GroupLicenceDynamic);
                    amount += dynamic.monthAmount;
                }
                this.paymentInfoElement.getElementsByClassName('date')[0].innerHTML = moment(this.groupLicence.list[0].GroupLicenceNextRenewal).format("MMMM Do YYYY");
                this.paymentInfoElement.getElementsByClassName('amount')[0].innerHTML = amount;
            }

        }

    }

    getLicenceInfo() {

        this.licenses = JSON.parse(localStorage.getItem(this.addonsIds.join(',') + "-addons"));
        this.setupPaymentInfo();
        this.setupLicenceInfo();
        this.setupPaypal();
        this.setupCard();
        this.overlay = document.getElementsByClassName('overlay')[0];
        this.spinner = new Spinner({
            color:'#fff',
            lines: 12,
            top: '50%', // Top position relative to parent
            left: '50%', // Left position relative to parent
            position: 'absolute' // Element positioning
        }).spin(this.overlay);
    }

    setupLicenceInfo() {
        let addonsStrs = [];
        if (!this.groupLicence) {
            for (let licenseId in this.licenses) {
                if (this.licenses.hasOwnProperty(licenseId)) {
                    addonsStrs.push(this.licenses[licenseId].name + " x" + this.licenses[licenseId].count);
                }
            }
        } else {
            if (this.groupLicence.list === undefined) {
                let dynamic = JSON.parse(this.groupLicence.GroupLicenceDynamic);
                addonsStrs.push(dynamic.name + " x" + dynamic.count);
            } else {
                for (let i = 0; i < this.groupLicence.list.length; i++) {
                    let dynamic = JSON.parse(this.groupLicence.list[i].GroupLicenceDynamic);
                    addonsStrs.push(dynamic.name + " x" + dynamic.count);
                }
            }

        }

        this.licenceInfoElement.innerHTML = "Addons: " + addonsStrs.join(", ");
    }

    setupSubscription(paymentType) {
        var request = new XMLHttpRequest();

        request.onreadystatechange = function() {
            if (request.readyState == 4) {
                if (request.status !== 200) {
                    this.overlay.style.display = 'none';this.overlay.style.display = 'none';
                    return this.paymentError('Their was an error dealing with your request please try again.');
                }

                var response = JSON.parse(request.responseText);
                if (!response.success) {
                    this.overlay.style.display = 'none';
                    return this.paymentError('Invalid payment details');
                }

                if (response.approval_url) {
                    window.location.href = response.approval_url;
                } else if (response.redirectToAccount) {
                    window.location.href = "/account.html";
                }
            }
        }.bind(this);

        var data = {
            payment: paymentType,
            paymentTerm: 'MONTH',
            licenses: this.licenses,
            groupLicenceId: this.groupLicenceId
        };

        if (paymentType === 'credit_card') {
            data.card = {};
            data.card.type = this.card.cardType;
            data.card.number = Number(this.card.$numberInput[0].value.replace(/[^\d]/g, ''));

            var firstName = this.paymentTypesElement.getElementsByClassName('first_name')[0];
            var lastName = this.paymentTypesElement.getElementsByClassName('last_name')[0];

            data.card.first_name = firstName.value;
            data.card.last_name = lastName.value;

            data.card.cvv2 = this.card.$cvcInput[0].value;

            var expiry = PaymentValid.fns.cardExpiryVal(this.card.$expiryInput[0].value);

            data.card.expire_month = expiry.month;
            data.card.expire_year = expiry.year;

            if (!this.validateCard(data.card)) {
                return;
            }
        }

        if (this.suspended) {
            data.suspended = true;
        }

        if (this.rewrite) {
            data.rewriteAgreement = true;
            data.agreementId = this.groupLicence.list ? this.groupLicence.list[0].groupLicenseAgreementID : this.groupLicence.groupLicenseAgreementID;
        }

        let userData = JSON.parse(this.authDataStorage.getUserData());

        request.open("POST", Config.BACKEND_URL + '/createAddonBillingAgreement');
        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
        request.setRequestHeader("auth-token", userData.token);
        request.send(JSON.stringify(data));
    }
}



// WEBPACK FOOTER //
// ./src/AddonsPayment.js